import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EDITCOWORKER_REQ, GETCOWORKER_REQ } from "../../actions";
import {
  CoworkerForm,
  useCoworkerForm,
} from "../coworkers/components/coworker_form";

import { Popup } from "../../components/pop-up";
import { FlatButton } from "../../components/buttons";
import { EDITCOWORKER_RESPONSE } from "../../constants/action_types";

const isValidURL = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export function GeneralSettings() {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState();

  const profilePicInput = useRef();

  const coworkerDetails = useSelector(
    (state) => state?.coworker?.details?.coworker
  );

  const coworkerUpdated = useSelector(
    (state) => state.coworker.update_response
  );

  useEffect(() => {
    if (coworkerUpdated?.type === EDITCOWORKER_RESPONSE) {
      dispatch(GETCOWORKER_REQ(coworkerDetails));
    }
  }, [coworkerUpdated]);

  const updateCoworker = () => {
    setOpenModal();
    dispatch(EDITCOWORKER_REQ(coworkerForm.values));
  };
  const coworkerForm = useCoworkerForm(coworkerDetails, "Edit", () => {
    setOpenModal("pop-up");
  });
  return (
    <div className="grid max-w-[86rem] grid-cols-1 gap-x-8 px-4 mb-4 sm:px-6 md:grid-cols-2 lg:px-8">
      <div className="md:col-span-5">
        <div className="grid grid-cols-1 mt-16 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
          <div className="col-span-full flex items-center gap-x-8">
            <div className="relative">
              <img
                src={
                  coworkerForm.values.profile_pic &&
                  typeof coworkerForm.values.profile_pic === "object"
                    ? URL.createObjectURL(coworkerForm.values.profile_pic)
                    : typeof coworkerForm.values.profile_pic === "string" &&
                      !isValidURL(coworkerForm.values.profile_pic)
                    ? `${process.env.REACT_APP_ATTACHMENT_URL}${coworkerForm.values.profile_pic}`
                    : coworkerForm.values.profile_pic
                }
                alt=""
                className={`${
                  coworkerForm.values.profile_pic ? "" : "hidden"
                } peer inline-block h-24 w-24 flex-none rounded-lg bg-gray-800 object-cover`}
              />
              {!coworkerForm.values.profile_pic && (
                <div className=" h-24 w-24 flex-none border-gray-300 border rounded-lg">
                  <svg
                    class=" text-gray-300 inline-block"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
              )}
              {coworkerForm.values.profile_pic && (
                <div
                  onClick={() => {
                    coworkerForm.setFieldValue("profile_pic", "");
                    coworkerForm.setFieldTouched("prfile_pic", true);
                  }}
                  className="opacity-0 cursor-pointer rounded-lg hover:opacity-100 peer-hover:opacity-100 w-full h-full absolute top-0 transition-all flex justify-center items-center bg-red-600/50"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={3.5}
                    stroke="currentColor"
                    className="stroke-white w-10 h-10"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div>
              <FlatButton
                onClick={() => {
                  profilePicInput.current?.click();
                }}
              >
                Change avatar
              </FlatButton>

              <input
                ref={profilePicInput}
                className="hidden"
                type="file"
                accept=".png,.jpg,.jpeg"
                onChange={(e) => {
                  // let reader = new FileReader();
                  let file = e.target.files[0];
                  coworkerForm.setFieldValue("profile_pic", file);
                  setTimeout(() => coworkerForm.setFieldTouched("profile_pic"));
                }}
              />
            </div>
          </div>
        </div>

        <CoworkerForm
          //   className="[&>.email]:hidden"
          showProfile={false}
          formik={coworkerForm}
          mode="Edit"
        />
      </div>
      <div className="col-span-5 flex gap-x-5 items-center justify-end">
        <FlatButton
          size="lg"
          appearance="secondary"
          disabled={!coworkerForm.dirty}
          onClick={() => {
            coworkerForm.resetForm();
          }}
          className="w-[120px]"
        >
          Cancel
        </FlatButton>
        <FlatButton
          size="lg"
          onClick={() => {
            coworkerForm.submitForm();
          }}
          className="w-[120px]"
        >
          Save
        </FlatButton>
      </div>
      <Popup
        modalState={[openModal, setOpenModal]}
        onConfirm={updateCoworker}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to edit your profile?
            </h3>
          </>
        }
      />
    </div>
  );
}
